import React from 'react'
import PropTypes from 'prop-types'
import SortIcon from './SortIcon'

const TableSort = ({ orderBy, columnList, toggleSort, toggleMultiSort, hiddenColumns }) => {
    return (
        <tr>
            {columnList
                .filter(column => !hiddenColumns.includes(column.property))
                .map(({ width, property, header, columnName }) => {
                return (
                    <th
                        key={property}
                        width={width || ''}
                        onClick={(event) => {
                            const isShiftKeyPressed = event.nativeEvent.shiftKey
                            if (isShiftKeyPressed) {
                                toggleMultiSort(columnName)
                            } else {
                                toggleSort(columnName)
                            }
                        }}>
                        {header}&#160;<SortIcon orderBy={orderBy} columnName={columnName}/>
                    </th>
                )
            })}
        </tr>
    )
}

TableSort.propTypes = {
    columnList: PropTypes.array.isRequired,
    toggleSort: PropTypes.func.isRequired,
    toggleMultiSort: PropTypes.func.isRequired,
    orderBy: PropTypes.object.isRequired,
}

export default TableSort




// WEBPACK FOOTER //
// ./src/modules/table/component/TableSort.js